<template>
  <div class="tablelist">
    <div class="row align--center">

      <div class="flex xs8 md3">
        <va-input v-model="dDocument" placeholder="Documento" @change="search">
          <va-icon name="fa fa-search" slot="prepend" />
        </va-input>
      </div>

      <div class="flex xs18 md3">
        <va-select
          v-model="ListFacultyOptionsModel"
          textBy="description"
          placeholder="Periodos"
          :options="this.ListFacultyOptions"
          @change="search"
        />
      </div>

       <div class="flex xs8 md2">
        <va-input v-model="dYear" placeholder="Año" @change="search">

        </va-input>
      </div>

      <!--<div class="flex xs12 md3">
        <va-select
          v-model="ProgramsOptionsModel"
          textBy="description"
          placeholder="Programa"
          :options="this.ProgramsOptions"
          @change="search"
        />
      </div>-->
      <div class="flex xs12 md2 offset--md2">
        <va-select
          v-model="perPage"
          :label="$t('tables.perPage')"
          :options="perPageOptions"
        />
      </div>
    </div>
    <va-data-table
      :fields="fields"
      :data="filteredData"
      :per-page="parseInt(perPage)"
      no-data-label="No se encuentran datos para esta busqueda"
    >
    </va-data-table>
    <div class="text-right">
      <button class="loginbtn primaryBtn" type="submit" v-on:click="exportExcel">
        <va-icon name="fa fa-download" size="60" /> Exportar Excel
      </button>
    </div>
  </div>
</template>

<script>
import { debounce } from 'lodash'
import XLSX from 'xlsx'
import IberoHelpers2 from '@/store/helpers.js'

var filtro = 'NA'

export default {
  name: 'Report',
  data () {
    return {
      term: null,
      perPage: '20',
      perPageOptions: ['5', '10', '20', '50', '100'],
      StatusOptions: [
        {
          id: 1,
          description: 'Activo',
        },
        {
          id: 2,
          description: 'Inactivo',
        },
      ],
      StatusOptionsModel: '',
      InfoData: this.InfoView,
      ProgramsOptions: this.filterData.ListPrograms,
      ProgramsOptionsModel: '',
      ListFacultyOptions: this.filterData.ListFaculty,
      ListFacultyOptionsModel: '',
      dDocument: '',
      dYear: '',
      arrayReport: [],
    }
  },
  props: {
    method: Function,
    InfoView: Array,
    HeadTable: Array,
    filterData: Array,
  },
  computed: {
    fields () {
      return this.HeadTable
    },
    filteredData () {
      if (
        (!this.term || this.term.length < 1) &&
        !this.StatusOptionsModel.id &&
        !this.ListFacultyOptionsModel &&
        !this.ProgramsOptionsModel &&
        !this.dDocument &&
        !this.dYear
      ) {
        return this.InfoData
      }

      if (filtro === this.ListFacultyOptionsModel + this.dDocument + this.dYear) {
        return this.InfoData
      }
      debugger
      if (filtro !== this.ListFacultyOptionsModel + this.dDocument + this.dYear) {
        var OrdenData2 = IberoHelpers2.getOrdenesGeneradasdata(this.$store, this.ListFacultyOptionsModel, this.dDocument, this.dYear)
        OrdenData2.then((Response) => {
          if (Response.data) {
            if (Array.isArray(Response.data)) {
              this.InfoData = Response.data
            } else {
              console.log('errores')
            }
          } else {
            return this.InfoData
          }
          IberoHelpers2.forceRerender1(this)
        })

        filtro = this.ListFacultyOptionsModel + this.dDocument + this.dYear
        return this.InfoData
      }
    },
  },
  methods: {
    listData: function (infData) {
      var refZohoOutput = JSON.parse(infData)
      return JSON.parse(refZohoOutput.details.output).dataCase[0].Case_Number
    },
    exportExcel: function () {
      if (this.filteredData.length >= 1) {
        this.arrayReport.length = 0
        let listCurso = 1
        let loader = this.$loading.show()
        for (var i = 0; i < this.filteredData.length; i++) {
          this.arrayReport.push({
            'ID': listCurso,
            'Periodo': this.filteredData[i].periodo,
            'Orden': this.filteredData[i].orden,
            'Doc IDENTIDAD': this.filteredData[i].doC_IDENTIDAD,
            'Gocumento': this.filteredData[i].documento,
            'Organización': this.filteredData[i].organizacion,
            'Tipo Orden': this.filteredData[i].tipO_ORDEN,
            'Descuento': this.filteredData[i].descuento,
            'Tipo Eentrega': this.filteredData[i].tipO_ENTREGA,
            'Fecha Orden': this.filteredData[i].fechA_ORDEN,
            'Fecha Liquidación': this.filteredData[i].fechA_LIQUIDACION,
            'Entrega Parcial': this.filteredData[i].entregA_PARCIAL,
            'Estado': this.filteredData[i].estado,
            'Cliente': this.filteredData[i].cliente,
            'Orden Compra': this.filteredData[i].ordeN_COMPRA,
            'Cliente Solicitado': this.filteredData[i].clientE_SOLICITADO,
            'Centro Costo': this.filteredData[i].centrO_COSTO,
            'Fondo': this.filteredData[i].fondo,
            'Fecha Vencimiento': this.filteredData[i].fechA_VENCIMIENTO,
            'Valor Bruto': this.filteredData[i].valoR_BRUTO,
            'Valor Descuento': this.filteredData[i].valoR_DESCUENTO,
            'Valor IVA': this.filteredData[i].valoR_IVA,
            'Valor Total': this.filteredData[i].valoR_TOTAL,
            'Grupo': this.filteredData[i].grupo,
            'Genera Mora': this.filteredData[i].generA_MORA,
            'Tasa Interes Mora': this.filteredData[i].tasA_INTERES_MORA,
            'Fuente Función': this.filteredData[i].fuentE_FUNCION,
            'Ciclo': this.filteredData[i].ciclo,
            'Documento Saldo': this.filteredData[i].documentO_SALDO,
            'Creditos Academicos': this.filteredData[i].creditoS_ACADEMICOS,
            'Moneda': this.filteredData[i].moneda,
          })
          listCurso++
          // }
        }

        var dateRef = new Date()
        var month = '' + (dateRef.getMonth() + 1)
        var day = '' + dateRef.getDate()
        if (month.length < 2) {
          month = '0' + month
        }
        if (day.length < 2) {
          day = '0' + day
        }
        const filename = 'IberoReporte_' + day + month + dateRef.getFullYear()

        let data = XLSX.utils.json_to_sheet(this.arrayReport)
        const workbook = XLSX.utils.book_new()
        XLSX.utils.book_append_sheet(workbook, data, filename)
        XLSX.writeFile(workbook, `${filename}.xlsx`)
        loader.hide()
      }
    },
    dataReg (user, ref) {
      this.method(user, ref)
    },
    search: debounce(function (term) {
      this.term = term
    }, 400),
  },
}
</script>

<style>
.tablelist .va-button {
  color: #222 !important;
  border-color: #222 !important;
}

.tablelist .va-button--active {
  color: #ffffff !important;
  border-color: #222 !important;
  background-color: #222 !important;
}

.tablelist .va-select__label {
  color: #222 !important;
}
.va-select__option--selected {
  color: #222 !important;
}

.tablelist .va-button--small .va-button__content__title {
  color: #222 !important;
}

.va-table th,
.content table th {
  border-bottom: 2px solid #222 !important;
  font-size: 12px !important;
}

.va-data-table__vuetable th.sortable {
  color: #222 !important;
}

.imgdata {
  cursor: pointer;
  margin-left: 2px !important;
  margin-right: 2px !important;
}
ul.listUL {
  width: 300px !important;
  list-style-type: square;
}
</style>
